/*
https://d3j4vz29nirhst.cloudfront.net/comeon/sv_se/general/SPORTSBOOK_WELCOME_OFFER_BACKGROUND_IMAGE/14/finalnocta.png  -> main path
https://d3j4vz29nirhst.cloudfront.net/comeon/sv_se/general/SPORTSBOOK_WELCOME_OFFER_BACKGROUND_IMAGE/14/1920w/finalnocta.webp -> webp for 1920w
*/

function getSrcsetForResource(path: string, sizes: number[], type: string): string {
	if (!type) {
		return path; // Return original path if type is not provided
	}
	if (!sizes.length) {
		return path; // Return original path if sizes array is empty
	}

	// eslint-disable-next-line no-useless-escape
	const match = path.match(/(.+\/\d+\/)([^\/]+)\.(\w+)$/);
	if (!match) {
		return path; // Return original path if path does not match expected pattern
	}

	const [, basePath, name] = match;

	// Generate updated paths for each size and create srcset string
	const srcset = sizes
		.map(size => {
			const updatedPath = `${basePath}${size}w/${name}.${type}`;
			return `${updatedPath} ${size}w`;
		})
		.join(', ');

	return srcset;
}

export default getSrcsetForResource;
